export default function(Vue: any) {
    Vue.auth = {
        // setters
        setToken(accessToken: any): void {
            localStorage.setItem('token', accessToken);
        },

        setUser(user: string): void {
            // localStorage.setItem('user', JSON.stringify(user));
            localStorage.setItem('user', user);
        },

        // getters
        getToken(): any {
            const token = localStorage.getItem('token');
            return token;
        },

        getUser(): string {
            const user: any = localStorage.getItem('user');
            return user;
        },

        destroyToken(): void {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('customerDevId');
        },

        isAuthenticated(): boolean {
            if (this.getToken()) {
                return true;
            } else {
                return false;
            }
        },
    };

    Object.defineProperties(Vue.prototype, {
        $auth: {
            get: () => {
                return Vue.auth;
            },
        },
    });
}
